let filterVisualBoxByCategory = {
    setup : function() {
      this.$allContent= $('[data-specialattribute^="tab-"]');
      this.$macroCategoriesTab = $('#pills-tab .nav-link');
    },
 
    bindEvents:  function()  {

        this.$macroCategoriesTab.on('show.bs.tab', function(e){
            let $clikedTab = $(e.currentTarget).attr('href').replace('#', '');
            let $contentToShow = this.$allContent.filter('[data-specialattribute*="tab-'+$clikedTab+'"]');
            
            if( $clikedTab !== "all") {
                this.$allContent.attr('style', 'display: none !important'); //.d-block
                $contentToShow.attr('style', 'display: block !important');
            } else {
                this.$allContent.attr('style', 'display: block !important');
            }
            
        }.bind(this));
 
    },
  
    init: function () {
      try {
        this.setup();
        this.bindEvents();

      }
      catch (e) {
        console.error(e);
      } 
    }
  };
 
$(document).ready(function () {

    filterVisualBoxByCategory.init();

    $(".products-list__item").each(function(i) {

        $(this).find(">:first-child").mouseover(function () {
            $(this).children("picture").eq(1).siblings().find(">:last-child").removeClass("d-none")
            $(this).children("picture").eq(0).siblings().find(">:last-child").addClass("d-none")
        }).mouseout(function () {
            $(this).children("picture").eq(1).siblings().find(">:last-child").addClass("d-none")
            $(this).children("picture").eq(0).siblings().find(">:last-child").removeClass("d-none")
        })

    })

});